export default function CharlottesWebTickets() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Charlotte&apos;s Web
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<h3 className="font-bold">
						Get Your Tickets for Charlotte&apos;s Web!
					</h3>
					<p>
						Join us for a heartwarming production of Charlotte&apos;s
						Web--our first show on the EBHS stage in many years!
					</p>
					<br />
					<p>
						<span className="font-bold">
							Performance Dates & Times:
						</span>
						<ul>
							<li>
								<span>Friday, June 13 at 7 PM</span>
								<span className="ml-2 font-semibold text-red-600">
									(Sold Out)
								</span>
							</li>
							<li>
								<span>Saturday, June 14 at 2 PM</span>
								<span className="ml-2 font-semibold text-red-600">
									(Sold Out)
								</span>
							</li>
							<li>
								<span>Saturday, June 14 at 7 PM</span>
								<span className="ml-2 font-semibold text-red-600">
									(Sold Out)
								</span>
							</li>
						</ul>
					</p>
					<br />
					<p>
						<span className="font-bold text-red-600">
							All performances are currently sold out.
						</span>
						<br />
						<br />
						How to Buy Tickets:
						<br />
						<br />
						Send your payment via Venmo (@Sarah-Williams-2442) and
						include:
						<br />
						Your Name
						<br />
						Number of Tickets
						<br />
						Performance
						<br />
						<br />
						Please check back for updates on additional showings.
					</p>
					<p>
						Click here:{' '}
						<a
							href="https://venmo.com/Sarah-Williams-2442"
							className="text-blue-700 underline"
						>
							@Sarah-Williams-2442
						</a>{' '}
						or Scan this QR code to pay via Venmo:
						<br />
						<img
							src="/images/ebhs/events/2025-charlottes-web-pay-code.jpg"
							alt="qr code for venmo payment"
							className="w-80 py-3"
						/>
					</p>
				</div>
			</div>
		</>
	)
}
